import React from "react";
export default function DurationOld({ className, seconds }) {
  return (
    <time
      dateTime={`P${Math.round(seconds)}S`}
      style={{ fontWeight: "600", fontSize: "1rem" }}
      className={className}
    >
      {format(seconds)}
    </time>
    // <div>{format(seconds)}</div>
  );
}

function format(seconds) {
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = pad(date.getUTCSeconds());
  return `${hh}:${pad(mm)}:${ss}`;
}

function pad(string) {
  return ("0" + string).slice(-2);
}
